// One language choice applies to every example box on the page, so a single delegated listener
// drives all of them rather than each one acting independently.
const STORAGE_KEY = "shopfront-example-language";

export function initExampleLanguageSwitcher(): void {
    const panels = document.querySelectorAll<HTMLElement>("[data-example-lang]");
    const options = document.querySelectorAll<HTMLElement>("[data-example-lang-option]");

    if(!options.length) {
        return;
    }

    const available: Array<string> = [];

    options.forEach(option => {
        const lang = option.getAttribute("data-example-lang-option");

        if(lang && !available.includes(lang)) {
            available.push(lang);
        }
    });

    function apply(lang: string): void {
        panels.forEach(panel => {
            const panelLang = panel.getAttribute("data-example-lang");

            // Whether to toggle a panel depends on its own example box having a switcher, not on
            // whether its language happens to match one used elsewhere on the page - a standalone
            // single-language example (no switcher of its own) is left visible either way, even if
            // another example's switcher happens to offer the same language
            const hasOwnSwitcher = panel.closest(".example")?.querySelector("[data-example-lang-option]") !== null;

            if(panelLang && hasOwnSwitcher) {
                panel.hidden = panelLang !== lang;
            }
        });

        options.forEach(option => {
            const isActive = option.getAttribute("data-example-lang-option") === lang;

            option.classList.toggle("is-active", isActive);
            option.setAttribute("aria-selected", String(isActive));
        });
    }

    const stored = window.localStorage.getItem(STORAGE_KEY);

    apply(stored && available.includes(stored) ? stored : available[0]);

    document.addEventListener("click", e => {
        const option = (e.target as HTMLElement).closest<HTMLElement>("[data-example-lang-option]");
        const lang = option?.getAttribute("data-example-lang-option");

        if(!lang) {
            return;
        }

        window.localStorage.setItem(STORAGE_KEY, lang);
        apply(lang);
    });
}
